import { apiService } from "./api"
import type { LoginResponse, Restaurant } from "@/types"

export const authService = {
  async login(email: string, password: string, turnstileToken?: string): Promise<LoginResponse> {
    // eslint-disable-next-line no-console
    console.log("🔐 [AuthService] Login request", { email })
    try {
      const response = await apiService.post<LoginResponse>("/auth/login", {
        email,
        password,
        turnstileToken,
      })
      // eslint-disable-next-line no-console
      console.log("✅ [AuthService] Login successful", {
        userId: response.user?.id,
        role: response.user?.role,
      })

      // Po zalogowaniu, pobierz dane restauracji jeśli użytkownik jest właścicielem
      if (response.user && response.user.role === "restaurant_owner") {
        try {
          // Pobierz listę restauracji i użyj pierwszej dostępnej (tymczasowe rozwiązanie)
          const restaurants = await apiService.get<Restaurant[]>("/restaurants")
          if (restaurants && restaurants.length > 0) {
            // Tymczasowo użyj pierwszej dostępnej restauracji
            const firstRestaurant = restaurants[0]
            if (firstRestaurant) {
              response.restaurant = firstRestaurant
              console.log("Using restaurant:", firstRestaurant.name)
            }
          }
        } catch (error) {
          console.error("Error fetching restaurant data:", error)
        }
      }

      return response
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error("❌ [AuthService] Login failed", {
        status: error.response?.status,
        message: error.message,
      })
      // Przekaż błąd z odpowiednim komunikatem
      if (error.response?.status === 401) {
        throw new Error("Nieprawidłowy email lub hasło")
      } else if (error.response?.status === 400) {
        throw new Error("Nieprawidłowe dane logowania")
      } else {
        throw new Error("Błąd połączenia z serwerem")
      }
    }
  },

  async logout(): Promise<void> {
    // eslint-disable-next-line no-console
    console.log("🚪 [AuthService] Logout request")
    // Call backend logout to clear cookies
    try {
      await apiService.post("/auth/logout", {})
      // eslint-disable-next-line no-console
      console.log("✅ [AuthService] Logout successful")
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("❌ [AuthService] Error during logout:", error)
      // Continue even if logout fails
    }
  },

  async getProfile(): Promise<any> {
    // eslint-disable-next-line no-console
    console.log("🔍 [AuthService] Fetching user profile...")
    try {
      const profile = await apiService.get<any>("/auth/profile")
      // eslint-disable-next-line no-console
      console.log("✅ [AuthService] Profile fetched", {
        userId: profile?.id,
        role: profile?.role,
        isAnonymous: profile?.isAnonymous,
      })
      return profile
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("❌ [AuthService] Error fetching profile:", error)
      throw error
    }
  },

  async updateProfile(data: {
    preferredRestaurantId?: string
    currentLanguage?: string
  }): Promise<any> {
    return apiService.put("/auth/profile", data)
  },

  async updateAccount(data: {
    email?: string
    firstName?: string
    lastName?: string
    phone?: string
    password?: string
    currentLanguage?: string
    withdrawMarketingConsent?: boolean
    marketingConsentAccepted?: boolean
  }): Promise<any> {
    return apiService.put("/auth/profile", data)
  },

  async updateUserAccount(
    userId: string,
    data: {
      email?: string
      firstName?: string
      lastName?: string
      phone?: string
      password?: string
      currentLanguage?: string
      withdrawMarketingConsent?: boolean
      marketingConsentAccepted?: boolean
    }
  ): Promise<any> {
    return apiService.put(`/admin/users/${userId}`, data)
  },
}
